var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "youtube_2",
    d: "M27.1469 8.9875C26.8594 7.9125 26.0094 7.0625 24.9344 6.775C22.9844 6.25 15.1719 6.25 15.1719 6.25C15.1719 6.25 7.35938 6.25 5.40938 6.775C4.33438 7.0625 3.48439 7.9125 3.19689 8.9875C2.67189 10.9375 2.67188 15.0125 2.67188 15.0125C2.67188 15.0125 2.67189 19.0875 3.19689 21.0375C3.48439 22.1125 4.33438 22.925 5.40938 23.2125C7.35938 23.7375 15.1719 23.7375 15.1719 23.7375C15.1719 23.7375 22.9844 23.7375 24.9344 23.2125C26.0094 22.925 26.8594 22.1125 27.1469 21.0375C27.6719 19.0875 27.6719 15.0125 27.6719 15.0125C27.6719 15.0125 27.6719 10.9375 27.1469 8.9875ZM12.6719 18.75V11.25L18.9219 15L12.6719 18.75Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6821de8b9bf02f6dfe504348e7d8c44a.svg";
export { ForwardRef as ReactComponent };